if (window.matchMedia('(max-width: 749px)').matches) {
  const btn = document.querySelector(".js-show-more");
  const cards = [...document.querySelectorAll(".mt-values-card")];

  const sortedCards = cards.sort((a, b) => {
    return +getComputedStyle(a).order - +getComputedStyle(b).order;
  });


  sortedCards.forEach((card, i) => {
    if (i > 2) {
      card.style.display = "none";
      card.style.overflow = "hidden";
    }
  });

  btn.addEventListener("click", () => {
    sortedCards.forEach((card, i) => {
      if (i > 2) {
        card.style.display = "block";

        const height = card.scrollHeight;

        card.style.height = "0px";
        card.style.opacity = "0";

        card.animate(
          [
            { height: "0px", opacity: 0 },
            { height: height + "px", opacity: 1 }
          ],
          {
            duration: 500,
            easing: "ease",
            fill: "forwards"
          }
        );

        setTimeout(() => {
          card.style.height = "";
          card.style.opacity = "";
          card.style.overflow = "";
        }, 500);
      }
    });

    /* remove button */
    btn.animate(
      [
        { opacity: 1 },
        { opacity: 0 }
      ],
      {
        duration: 300,
        fill: "forwards"
      }
    );

    setTimeout(() => btn.parentElement.remove(), 300);
  });
}